module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/language-dropdown/language-dropdown.component.scss
// module id = ./src/app/components/language-dropdown/language-dropdown.component.scss
// module chunks = main